import i18nDataEN from "./i18nData-en";
import i18nDataES from "./i18nData-es";

export default {
  en: i18nDataEN,
  es: i18nDataES,
};
